(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (setImmediate){
/*************************
 * Croppie
 * Copyright 2016
 * Foliotek
 * Version: 2.3.0
 *************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['exports'], factory);
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports);
    } else {
        // Browser globals
        factory((root.commonJsStrict = {}));
    }
}(this, function (exports) {

    /* Polyfills */
    if (typeof Promise !== 'function') {
        /*! promise-polyfill 3.1.0 */
        !function(a){function b(a,b){return function(){a.apply(b,arguments)}}function c(a){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof a)throw new TypeError("not a function");this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this))}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c)return void(b._state?a.resolve:a.reject)(b._value);var d;try{d=c(b._value)}catch(e){return void a.reject(e)}a.resolve(d)})}function e(a){try{if(a===this)throw new TypeError("A promise cannot be resolved with itself.");if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void i(b(c,a),b(e,this),b(f,this))}this._state=!0,this._value=a,g.call(this)}catch(d){f.call(this,d)}}function f(a){this._state=!1,this._value=a,g.call(this)}function g(){for(var a=0,b=this._deferreds.length;b>a;a++)d.call(this,this._deferreds[a]);this._deferreds=null}function h(a,b,c,d){this.onFulfilled="function"==typeof a?a:null,this.onRejected="function"==typeof b?b:null,this.resolve=c,this.reject=d}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a))},function(a){d||(d=!0,c(a))})}catch(e){if(d)return;d=!0,c(e)}}var j=setTimeout,k="function"==typeof setImmediate&&setImmediate||function(a){j(a,1)},l=Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f))})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"==typeof g||"function"==typeof g)){var h=g.then;if("function"==typeof h)return void h.call(g,function(a){d(f,a)},c)}a[f]=g,0===--e&&b(a)}catch(i){c(i)}}if(0===a.length)return b([]);for(var e=a.length,f=0;f<a.length;f++)d(f,a[f])})},c.resolve=function(a){return a&&"object"==typeof a&&a.constructor===c?a:new c(function(b){b(a)})},c.reject=function(a){return new c(function(b,c){c(a)})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++)a[d].then(b,c)})},c._setImmediateFn=function(a){k=a},"undefined"!=typeof module&&module.exports?module.exports=c:a.Promise||(a.Promise=c)}(this);
    }

    if ( typeof window.CustomEvent !== "function" ) {
        (function(){
            function CustomEvent ( event, params ) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent( 'CustomEvent' );
                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
                return evt;
            }
            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        }());
    }
    /* End Polyfills */

    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
        emptyStyles = document.createElement('div').style,
        CSS_TRANS_ORG,
        CSS_TRANSFORM,
        CSS_USERSELECT;

    function vendorPrefix(prop) {
        if (prop in emptyStyles) {
            return prop;
        }

        var capProp = prop[0].toUpperCase() + prop.slice(1),
            i = cssPrefixes.length;

        while (i--) {
            prop = cssPrefixes[i] + capProp;
            if (prop in emptyStyles) {
                return prop;
            }
        }
    }

    CSS_TRANSFORM = vendorPrefix('transform');
    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
    CSS_USERSELECT = vendorPrefix('userSelect');

    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
    function deepExtend(destination, source) {
        destination = destination || {};
        for (var property in source) {
            if (source[property] && source[property].constructor && source[property].constructor === Object) {
                destination[property] = destination[property] || {};
                deepExtend(destination[property], source[property]);
            } else {
                destination[property] = source[property];
            }
        }
        return destination;
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function dispatchChange(element) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            element.dispatchEvent(evt);
        }
        else {
            element.fireEvent("onchange");
        }
    }

    //http://jsperf.com/vanilla-css
    function css(el, styles, val) {
        if (typeof (styles) === 'string') {
            var tmp = styles;
            styles = {};
            styles[tmp] = val;
        }

        for (var prop in styles) {
            el.style[prop] = styles[prop];
        }
    }

    function addClass(el, c) {
        if (el.classList) {
            el.classList.add(c);
        }
        else {
            el.className += ' ' + c;
        }
    }

    function removeClass(el, c) {
        if (el.classList) {
            el.classList.remove(c);
        }
        else {
            el.className = el.className.replace(c, '');
        }
    }

    /* Utilities */
    function loadImage(src, imageEl) {
        var img = imageEl || new Image(),
            prom;

        if (img.src === src) {
            // If image source hasn't changed, return a promise that resolves immediately
            prom = new Promise(function (resolve, reject) {
                resolve(img);
            });
        } else {
            prom = new Promise(function (resolve, reject) {
                if (src.substring(0,4).toLowerCase() === 'http') {
                    img.setAttribute('crossOrigin', 'anonymous');
                }
                img.onload = function () {
                    setTimeout(function () {
                        resolve(img);
                    }, 1);
                };
            });

            img.src = src;
        }

        img.style.opacity = 0;

        return prom;
    }

    /* CSS Transform Prototype */
    var _TRANSLATE = 'translate3d',
        _TRANSLATE_SUFFIX = ', 0px';
    var Transform = function (x, y, scale) {
        this.x = parseFloat(x);
        this.y = parseFloat(y);
        this.scale = parseFloat(scale);
    };

    Transform.parse = function (v) {
        if (v.style) {
            return Transform.parse(v.style[CSS_TRANSFORM]);
        }
        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
            return Transform.fromMatrix(v);
        }
        else {
            return Transform.fromString(v);
        }
    };

    Transform.fromMatrix = function (v) {
        var vals = v.substring(7).split(',');
        if (!vals.length || v === 'none') {
            vals = [1, 0, 0, 1, 0, 0];
        }

        return new Transform(parseInt(vals[4], 10), parseInt(vals[5], 10), parseFloat(vals[0]));
    };

    Transform.fromString = function (v) {
        var values = v.split(') '),
            translate = values[0].substring(_TRANSLATE.length + 1).split(','),
            scale = values.length > 1 ? values[1].substring(6) : 1,
            x = translate.length > 1 ? translate[0] : 0,
            y = translate.length > 1 ? translate[1] : 0;

        return new Transform(x, y, scale);
    };

    Transform.prototype.toString = function () {
        return _TRANSLATE + '(' + this.x + 'px, ' + this.y + 'px' + _TRANSLATE_SUFFIX + ') scale(' + this.scale + ')';
    };

    var TransformOrigin = function (el) {
        if (!el || !el.style[CSS_TRANS_ORG]) {
            this.x = 0;
            this.y = 0;
            return;
        }
        var css = el.style[CSS_TRANS_ORG].split(' ');
        this.x = parseFloat(css[0]);
        this.y = parseFloat(css[1]);
    };

    TransformOrigin.prototype.toString = function () {
        return this.x + 'px ' + this.y + 'px';
    };

    function getExifOrientation (img, cb) {
        if (!window.EXIF) {
            cb(0);
        }

        EXIF.getData(img, function () {
            var orientation = EXIF.getTag(this, 'Orientation');
            cb(orientation);
        });
    }

    function drawCanvas(canvas, img, orientation) {
        var width = img.width,
            height = img.height,
            ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.save();
        switch (orientation) {
          case 2:
             ctx.translate(width, 0);
             ctx.scale(-1, 1);
             break;

          case 3:
              ctx.translate(width, height);
              ctx.rotate(180*Math.PI/180);
              break;

          case 4:
              ctx.translate(0, height);
              ctx.scale(1, -1);
              break;

          case 5:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.scale(1, -1);
              break;

          case 6:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90*Math.PI/180);
              ctx.translate(0, -height);
              break;

          case 7:
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(-90*Math.PI/180);
              ctx.translate(-width, height);
              ctx.scale(1, -1);
              break;

          case 8:
              canvas.width = height;
              canvas.height = width;
              ctx.translate(0, width);
              ctx.rotate(-90*Math.PI/180);
              break;
        }
        ctx.drawImage(img, 0,0, width, height);
        ctx.restore();
    }

    /* Private Methods */
    function _create() {
        var self = this,
            contClass = 'croppie-container',
            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
            boundary, img, viewport, overlay, canvas;

        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
        // Properties on class
        self.data = {};
        self.elements = {};

        // Generating Markup
        boundary = self.elements.boundary = document.createElement('div');
        viewport = self.elements.viewport = document.createElement('div');
        img = self.elements.img = document.createElement('img');
        overlay = self.elements.overlay = document.createElement('div');

        if (self.options.useCanvas) {
            self.elements.canvas = document.createElement('canvas');
            self.elements.preview = self.elements.canvas;
        }
        else {
            self.elements.preview = self.elements.img;
        }

        addClass(boundary, 'cr-boundary');
        css(boundary, {
            width: self.options.boundary.width + 'px',
            height: self.options.boundary.height + 'px'
        });

        addClass(viewport, 'cr-viewport');
        if (customViewportClass) {
            addClass(viewport, customViewportClass);
        }
        css(viewport, {
            width: self.options.viewport.width + 'px',
            height: self.options.viewport.height + 'px'
        });
        viewport.setAttribute('tabindex', 0);

        addClass(self.elements.preview, 'cr-image');
        addClass(overlay, 'cr-overlay');

        self.element.appendChild(boundary);
        boundary.appendChild(self.elements.preview);
        boundary.appendChild(viewport);
        boundary.appendChild(overlay);

        addClass(self.element, contClass);
        if (self.options.customClass) {
            addClass(self.element, self.options.customClass);
        }

        // Initialize drag & zoom
        _initDraggable.call(this);

        if (self.options.enableZoom) {
            _initializeZoom.call(self);
        }

        // if (self.options.enableOrientation) {
        //     _initRotationControls.call(self);
        // }
    }

    function _initRotationControls () {
        // TODO - Not a fan of these controls
        return;
        var self = this,
            wrap, btnLeft, btnRight, iLeft, iRight;

        wrap = document.createElement('div');
        self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
        self.elements.orientationBtnRight = btnRight = document.createElement('button');

        wrap.appendChild(btnLeft);
        wrap.appendChild(btnRight);

        iLeft = document.createElement('i');
        iRight = document.createElement('i');
        btnLeft.appendChild(iLeft);
        btnRight.appendChild(iRight);

        addClass(wrap, 'cr-rotate-controls');
        addClass(btnLeft, 'cr-rotate-l');
        addClass(btnRight, 'cr-rotate-r');

        self.elements.boundary.appendChild(wrap);

        btnLeft.addEventListener('click', function () {
            self.rotate(-90);
        });
        btnRight.addEventListener('click', function () {
            self.rotate(90);
        });
    }

    function _hasExif() {
        // todo - remove options.exif after deprecation
        return this.options.enableExif && window.EXIF;
    }

    function _setZoomerVal(v) {
        if (this.options.enableZoom) {
            var z = this.elements.zoomer,
                val = fix(v, 4);

            z.value = Math.max(z.min, Math.min(z.max, val));
        }
    }

    function _initializeZoom() {
        var self = this,
            wrap = self.elements.zoomerWrap = document.createElement('div'),
            zoomer = self.elements.zoomer = document.createElement('input');

        addClass(wrap, 'cr-slider-wrap');
        addClass(zoomer, 'cr-slider');
        zoomer.type = 'range';
        zoomer.step = '0.0001';
        zoomer.value = 1;
        zoomer.style.display = self.options.showZoomer ? '' : 'none';

        self.element.appendChild(wrap);
        wrap.appendChild(zoomer);

        self._currentZoom = 1;

        function change() {
            _onZoom.call(self, {
                value: parseFloat(zoomer.value),
                origin: new TransformOrigin(self.elements.preview),
                viewportRect: self.elements.viewport.getBoundingClientRect(),
                transform: Transform.parse(self.elements.preview)
            });
        }

        function scroll(ev) {
            var delta, targetZoom;

            if (ev.wheelDelta) {
                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
            } else if (ev.deltaY) {
                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
            } else if (ev.detail) {
                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
            } else {
                delta = 0;
            }

            targetZoom = self._currentZoom + delta;

            ev.preventDefault();
            _setZoomerVal.call(self, targetZoom);
            change.call(self);
        }

        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
        self.elements.zoomer.addEventListener('change', change);

        if (self.options.mouseWheelZoom) {
            self.elements.boundary.addEventListener('mousewheel', scroll);
            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
        }
    }

    function _onZoom(ui) {
        var self = this,
            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview),
            transCss = {};

        function applyCss() {
            var transCss = {};
            transCss[CSS_TRANSFORM] = transform.toString();
            transCss[CSS_TRANS_ORG] = origin.toString();
            css(self.elements.preview, transCss);
        }

        self._currentZoom = ui ? ui.value : self._currentZoom;
        transform.scale = self._currentZoom;
        applyCss();


        if (self.options.enforceBoundary) {
            var boundaries = _getVirtualBoundaries.call(self, vpRect),
                transBoundaries = boundaries.translate,
                oBoundaries = boundaries.origin;

            if (transform.x >= transBoundaries.maxX) {
                origin.x = oBoundaries.minX;
                transform.x = transBoundaries.maxX;
            }

            if (transform.x <= transBoundaries.minX) {
                origin.x = oBoundaries.maxX;
                transform.x = transBoundaries.minX;
            }

            if (transform.y >= transBoundaries.maxY) {
                origin.y = oBoundaries.minY;
                transform.y = transBoundaries.maxY;
            }

            if (transform.y <= transBoundaries.minY) {
                origin.y = oBoundaries.maxY;
                transform.y = transBoundaries.minY;
            }
        }
        applyCss();
        _debouncedOverlay.call(self);
        _triggerUpdate.call(self);
    }

    function _getVirtualBoundaries(viewport) {
        var self = this,
            scale = self._currentZoom,
            vpWidth = viewport.width,
            vpHeight = viewport.height,
            centerFromBoundaryX = self.options.boundary.width / 2,
            centerFromBoundaryY = self.options.boundary.height / 2,
            imgRect = self.elements.preview.getBoundingClientRect(),
            curImgWidth = imgRect.width,
            curImgHeight = imgRect.height,
            halfWidth = vpWidth / 2,
            halfHeight = vpHeight / 2;

        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

        var originMinX = (1 / scale) * halfWidth;
        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

        var originMinY = (1 / scale) * halfHeight;
        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

        return {
            translate: {
                maxX: maxX,
                minX: minX,
                maxY: maxY,
                minY: minY
            },
            origin: {
                maxX: originMaxX,
                minX: originMinX,
                maxY: originMaxY,
                minY: originMinY
            }
        };
    }

    function _updateCenterPoint() {
        var self = this,
            scale = self._currentZoom,
            data = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
            pc = new TransformOrigin(self.elements.preview),
            top = (vpData.top - data.top) + (vpData.height / 2),
            left = (vpData.left - data.left) + (vpData.width / 2),
            center = {},
            adj = {};

        center.y = top / scale;
        center.x = left / scale;

        adj.y = (center.y - pc.y) * (1 - scale);
        adj.x = (center.x - pc.x) * (1 - scale);

        transform.x -= adj.x;
        transform.y -= adj.y;

        var newCss = {};
        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
        newCss[CSS_TRANSFORM] = transform.toString();
        css(self.elements.preview, newCss);
    }

    function _initDraggable() {
        var self = this,
            isDragging = false,
            originalX,
            originalY,
            originalDistance,
            vpRect,
            transform;

        function assignTransformCoordinates(deltaX, deltaY) {
            var imgRect = self.elements.preview.getBoundingClientRect(),
                top = transform.y + deltaY,
                left = transform.x + deltaX;

            if (self.options.enforceBoundary) {
                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
                    transform.y = top;
                }

                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
                    transform.x = left;
                }
            }
            else {
                transform.y = top;
                transform.x = left;
            }
        }

        function keyDown(ev) {
            var LEFT_ARROW  = 37,
                UP_ARROW    = 38,
                RIGHT_ARROW = 39,
                DOWN_ARROW  = 40;

            if (ev.shiftKey && (ev.keyCode == UP_ARROW || ev.keyCode == DOWN_ARROW)) {
                var zoom = 0.0;
                if (ev.keyCode == UP_ARROW) {
                    zoom = parseFloat(self.elements.zoomer.value, 10) + parseFloat(self.elements.zoomer.step, 10)
                }
                else {
                    zoom = parseFloat(self.elements.zoomer.value, 10) - parseFloat(self.elements.zoomer.step, 10)
                }
                self.setZoom(zoom);
            }
            else if (ev.keyCode >= 37 && ev.keyCode <= 40) {
                ev.preventDefault();
                var movement = parseKeyDown(ev.keyCode);

                transform = Transform.parse(self.elements.preview);
                document.body.style[CSS_USERSELECT] = 'none';
                vpRect = self.elements.viewport.getBoundingClientRect();
                keyMove(movement);
            };

            function parseKeyDown(key) {
                switch (key) {
                    case LEFT_ARROW:
                        return [1, 0];
                    case UP_ARROW:
                        return [0, 1];
                    case RIGHT_ARROW:
                        return [-1, 0];
                    case DOWN_ARROW:
                        return [0, -1];
                };
            };
        }

        function keyMove(movement) {
            var deltaX = movement[0],
                deltaY = movement[1],
                newCss = {};

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        function mouseDown(ev) {
            ev.preventDefault();
            if (isDragging) return;
            isDragging = true;
            originalX = ev.pageX;
            originalY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                originalX = touches.pageX;
                originalY = touches.pageY;
            }

            transform = Transform.parse(self.elements.preview);
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('touchmove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
            window.addEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = 'none';
            vpRect = self.elements.viewport.getBoundingClientRect();
        }

        function mouseMove(ev) {
            ev.preventDefault();
            var pageX = ev.pageX,
                pageY = ev.pageY;

            if (ev.touches) {
                var touches = ev.touches[0];
                pageX = touches.pageX;
                pageY = touches.pageY;
            }

            var deltaX = pageX - originalX,
                deltaY = pageY - originalY,
                newCss = {};

            if (ev.type == 'touchmove') {
                if (ev.touches.length > 1) {
                    var touch1 = ev.touches[0];
                    var touch2 = ev.touches[1];
                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

                    if (!originalDistance) {
                        originalDistance = dist / self._currentZoom;
                    }

                    var scale = dist / originalDistance;

                    _setZoomerVal.call(self, scale);
                    dispatchChange(self.elements.zoomer);
                    return;
                }
            }

            assignTransformCoordinates(deltaX, deltaY);

            newCss[CSS_TRANSFORM] = transform.toString();
            css(self.elements.preview, newCss);
            _updateOverlay.call(self);
            originalY = pageY;
            originalX = pageX;
        }

        function mouseUp() {
            isDragging = false;
            window.removeEventListener('mousemove', mouseMove);
            window.removeEventListener('touchmove', mouseMove);
            window.removeEventListener('mouseup', mouseUp);
            window.removeEventListener('touchend', mouseUp);
            document.body.style[CSS_USERSELECT] = '';
            _updateCenterPoint.call(self);
            _triggerUpdate.call(self);
            originalDistance = 0;
        }

        self.elements.overlay.addEventListener('mousedown', mouseDown);
        self.elements.viewport.addEventListener('keydown', keyDown);
        self.elements.overlay.addEventListener('touchstart', mouseDown);
    }

    function _updateOverlay() {
        var self = this,
            boundRect = self.elements.boundary.getBoundingClientRect(),
            imgData = self.elements.preview.getBoundingClientRect();

        css(self.elements.overlay, {
            width: imgData.width + 'px',
            height: imgData.height + 'px',
            top: (imgData.top - boundRect.top) + 'px',
            left: (imgData.left - boundRect.left) + 'px'
        });
    }
    var _debouncedOverlay = debounce(_updateOverlay, 500);

    function _triggerUpdate() {
        var self = this,
            data = self.get(),
            ev; 

        if (!_isVisible.call(self)) {
            return;
        }

        self.options.update.call(self, data);
        if (self.$) {
            self.$(self.element).trigger('update', data)
        }
        else {
            var ev;
            if (window.CustomEvent) {
                ev = new CustomEvent('update', { detail: data });
            } else {
                ev = document.createEvent('CustomEvent');
                ev.initCustomEvent('update', true, true, data);
            }

            self.element.dispatchEvent(ev);
        }
    }

    function _isVisible() {
        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
    }

    function _updatePropertiesFromImage() {
        var self = this,
            minZoom = 0,
            maxZoom = 1.5,
            initialZoom = 1,
            cssReset = {},
            img = self.elements.preview,
            zoomer = self.elements.zoomer,
            transformReset = new Transform(0, 0, initialZoom),
            originReset = new TransformOrigin(),
            isVisible = _isVisible.call(self),
            imgData,
            vpData,
            boundaryData,
            minW,
            minH;

        if (!isVisible || self.data.bound) {
            // if the croppie isn't visible or it doesn't need binding
            return;
        }

        self.data.bound = true;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        cssReset[CSS_TRANS_ORG] = originReset.toString();
        cssReset['opacity'] = 1;
        css(img, cssReset);

        imgData = img.getBoundingClientRect();
        vpData = self.elements.viewport.getBoundingClientRect();
        boundaryData = self.elements.boundary.getBoundingClientRect();
        self._originalImageWidth = imgData.width;
        self._originalImageHeight = imgData.height;

        if (self.options.enableZoom) {
            if (self.options.enforceBoundary) {
                minW = vpData.width / imgData.width;
                minH = vpData.height / imgData.height;
                minZoom = Math.max(minW, minH);
            }

            if (minZoom >= maxZoom) {
                maxZoom = minZoom + 1;
            }

            zoomer.min = fix(minZoom, 4);
            zoomer.max = fix(maxZoom, 4);
            var defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
            _setZoomerVal.call(self, initialZoom);
            dispatchChange(zoomer);
        }
        else {
            self._currentZoom = initialZoom;
        }
        
        transformReset.scale = self._currentZoom;
        cssReset[CSS_TRANSFORM] = transformReset.toString();
        css(img, cssReset);

        if (self.data.points.length) {
            _bindPoints.call(self, self.data.points);
        }
        else {
            _centerImage.call(self);
        }

        _updateCenterPoint.call(self);
        _updateOverlay.call(self);
    }

    function _bindPoints(points) {
        if (points.length != 4) {
            throw "Croppie - Invalid number of points supplied: " + points;
        }
        var self = this,
            pointsWidth = points[2] - points[0],
            // pointsHeight = points[3] - points[1],
            vpData = self.elements.viewport.getBoundingClientRect(),
            boundRect = self.elements.boundary.getBoundingClientRect(),
            vpOffset = {
                left: vpData.left - boundRect.left,
                top: vpData.top - boundRect.top
            },
            scale = vpData.width / pointsWidth,
            originTop = points[1],
            originLeft = points[0],
            transformTop = (-1 * points[1]) + vpOffset.top,
            transformLeft = (-1 * points[0]) + vpOffset.left,
            newCss = {};

        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
        css(self.elements.preview, newCss);

        _setZoomerVal.call(self, scale);
        self._currentZoom = scale;
    }

    function _centerImage() {
        var self = this,
            imgDim = self.elements.preview.getBoundingClientRect(),
            vpDim = self.elements.viewport.getBoundingClientRect(),
            boundDim = self.elements.boundary.getBoundingClientRect(),
            vpLeft = vpDim.left - boundDim.left,
            vpTop = vpDim.top - boundDim.top,
            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
            h = vpTop - ((imgDim.height - vpDim.height) / 2),
            transform = new Transform(w, h, self._currentZoom);

        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
    }

    function _transferImageToCanvas(customOrientation) {
        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            ctx = canvas.getContext('2d'),
            exif = _hasExif.call(self),
            customOrientation = self.options.enableOrientation && customOrientation;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = img.width;
        canvas.height = img.height;

        if (exif) {
            getExifOrientation(img, function (orientation) {
                drawCanvas(canvas, img, parseInt(orientation));
                if (customOrientation) {
                    drawCanvas(canvas, img, customOrientation);
                }
            });
        } else if (customOrientation) {
            drawCanvas(canvas, img, customOrientation);
        }
    }

    function _getHtmlResult(data) {
        var points = data.points,
            div = document.createElement('div'),
            img = document.createElement('img'),
            width = points[2] - points[0],
            height = points[3] - points[1];

        addClass(div, 'croppie-result');
        div.appendChild(img);
        css(img, {
            left: (-1 * points[0]) + 'px',
            top: (-1 * points[1]) + 'px'
        });
        img.src = data.url;
        css(div, {
            width: width + 'px',
            height: height + 'px'
        });

        return div;
    }

    function _getCanvasResult(img, data) {
        var points = data.points,
            left = points[0],
            top = points[1],
            width = (points[2] - points[0]),
            height = (points[3] - points[1]),
            circle = data.circle,
            canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d'),
            outWidth = width,
            outHeight = height;

        if (data.outputWidth && data.outputHeight) {
            outWidth = data.outputWidth;
            outHeight = data.outputHeight;
        }

        canvas.width = outWidth;
        canvas.height = outHeight;

        if (data.backgroundColor) {
            ctx.fillStyle = data.backgroundColor;
            ctx.fillRect(0, 0, outWidth, outHeight);
        }
        ctx.drawImage(img, left, top, width, height, 0, 0, outWidth, outHeight);
        if (circle) {
            ctx.fillStyle = '#fff';
            ctx.globalCompositeOperation = 'destination-in';
            ctx.beginPath();
            ctx.arc(outWidth / 2, outHeight / 2, outWidth / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
        }
        return canvas.toDataURL(data.format, data.quality);
    }

    function _bind(options, cb) {
        var self = this,
            url,
            points = [],
            zoom = null;

        if (typeof (options) === 'string') {
            url = options;
            options = {};
        }
        else if (Array.isArray(options)) {
            points = options.slice();
        }
        else if (typeof (options) == 'undefined' && self.data.url) { //refreshing
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            return null;
        }
        else {
            url = options.url;
            points = options.points || [];
            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
        }

        self.data.bound = false;
        self.data.url = url || self.data.url;
        self.data.points = (points || self.data.points).map(function (p) {
            return parseFloat(p);
        });
        self.data.boundZoom = zoom;
        var prom = loadImage(url, self.elements.img);
        prom.then(function () {
            if (self.options.useCanvas) {
                self.elements.img.exifdata = null;
                _transferImageToCanvas.call(self, options.orientation || 1);
            }
            _updatePropertiesFromImage.call(self);
            _triggerUpdate.call(self);
            if (cb) {
                cb();
            }
        });
        return prom;
    }

    function fix(v, decimalPoints) {
        return parseFloat(v).toFixed(decimalPoints || 0);
    }

    function _get() {
        var self = this,
            imgData = self.elements.preview.getBoundingClientRect(),
            vpData = self.elements.viewport.getBoundingClientRect(),
            x1 = vpData.left - imgData.left,
            y1 = vpData.top - imgData.top,
            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2,
            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
            scale = self._currentZoom;

        if (scale === Infinity || isNaN(scale)) {
            scale = 1;
        }

        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
        x1 = Math.max(max, x1 / scale);
        y1 = Math.max(max, y1 / scale);
        x2 = Math.max(max, x2 / scale);
        y2 = Math.max(max, y2 / scale);

        return {
            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
            zoom: scale
        };
    }

    var RESULT_DEFAULTS = {
            type: 'canvas',
            format: 'png',
            quality: 1
        },
        RESULT_FORMATS = ['jpeg', 'webp', 'png'];

    function _result(options) {
        var self = this,
            data = _get.call(self),
            opts = deepExtend(RESULT_DEFAULTS, deepExtend({}, options)),
            type = (typeof (options) === 'string' ? options : (opts.type || 'viewport')),
            size = opts.size,
            format = opts.format,
            quality = opts.quality,
            backgroundColor = opts.backgroundColor,
            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
            vpRect = self.elements.viewport.getBoundingClientRect(),
            ratio = vpRect.width / vpRect.height,
            prom;

        if (size === 'viewport') {
            data.outputWidth = vpRect.width;
            data.outputHeight = vpRect.height;
        } else if (typeof size === 'object') {
            if (size.width && size.height) {
                data.outputWidth = size.width;
                data.outputHeight = size.height;
            } else if (size.width) {
                data.outputWidth = size.width;
                data.outputHeight = size.width / ratio;
            } else if (size.height) {
                data.outputWidth = size.height * ratio;
                data.outputHeight = size.height;
            }
        }

        if (RESULT_FORMATS.indexOf(format) > -1) {
            data.format = 'image/' + format;
            data.quality = quality;
        }

        data.circle = circle;
        data.url = self.data.url;
        data.backgroundColor = backgroundColor;

        prom = new Promise(function (resolve, reject) {
            if (type === 'canvas') {
                resolve(_getCanvasResult.call(self, self.elements.preview, data));
            }
            else {
                resolve(_getHtmlResult.call(self, data));
            }
        });
        return prom;
    }

    function _refresh() {
        _updatePropertiesFromImage.call(this);
    }

    function _rotate(deg) {
        if (!this.options.useCanvas) {
            throw 'Croppie: Cannot rotate without enableOrientation';
        }

        var self = this,
            canvas = self.elements.canvas,
            img = self.elements.img,
            copy = document.createElement('canvas'),
            ornt = 1;

        copy.width = canvas.width;
        copy.height = canvas.height;
        var ctx = copy.getContext('2d');
        ctx.drawImage(canvas, 0, 0);

        if (deg === 90 || deg === -270) ornt = 6;
        if (deg === -90 || deg === 270) ornt = 8;
        if (deg === 180 || deg === -180) ornt = 3;

        drawCanvas(canvas, copy, ornt);
        _onZoom.call(self);
    }

    function _destroy() {
        var self = this;
        self.element.removeChild(self.elements.boundary);
        removeClass(self.element, 'croppie-container');
        if (self.options.enableZoom) {
            self.element.removeChild(self.elements.zoomerWrap);
        }
        delete self.elements;
    }

    if (window.jQuery) {
        var $ = window.jQuery;
        $.fn.croppie = function (opts) {
            var ot = typeof opts;

            if (ot === 'string') {
                var args = Array.prototype.slice.call(arguments, 1);
                var singleInst = $(this).data('croppie');

                if (opts === 'get') {
                    return singleInst.get();
                }
                else if (opts === 'result') {
                    return singleInst.result.apply(singleInst, args);
                }
                else if (opts === 'bind') {
                    return singleInst.bind.apply(singleInst, args);
                }

                return this.each(function () {
                    var i = $(this).data('croppie');
                    if (!i) return;

                    var method = i[opts];
                    if ($.isFunction(method)) {
                        method.apply(i, args);
                        if (opts === 'destroy') {
                            $(this).removeData('croppie');
                        }
                    }
                    else {
                        throw 'Croppie ' + opts + ' method not found';
                    }
                });
            }
            else {
                return this.each(function () {
                    var i = new Croppie(this, opts);
                    i.$ = $;
                    $(this).data('croppie', i);
                });
            }
        };
    }

    function Croppie(element, opts) {
        this.element = element;
        this.options = deepExtend(deepExtend({}, Croppie.defaults), opts);

        _create.call(this);
        if (this.options.url) {
            var bindOpts = {
                url: this.options.url,
                points: this.options.points
            };
            delete this.options['url'];
            delete this.options['points'];
            _bind.call(this, bindOpts);
        }
    }

    Croppie.defaults = {
        viewport: {
            width: 100,
            height: 100,
            type: 'square'
        },
        boundary: {
            width: 300,
            height: 300
        },
        orientationControls: {
            enabled: true,
            leftClass: '',
            rightClass: ''
        },
        customClass: '',
        showZoomer: true,
        enableZoom: true,
        mouseWheelZoom: true,
        enableExif: false,
        enforceBoundary: true,
        enableOrientation: false,
        update: function () { }
    };

    deepExtend(Croppie.prototype, {
        bind: function (options, cb) {
            return _bind.call(this, options, cb);
        },
        get: function () {
            return _get.call(this);
        },
        result: function (type) {
            return _result.call(this, type);
        },
        refresh: function () {
            return _refresh.call(this);
        },
        setZoom: function (v) {
            _setZoomerVal.call(this, v);
            dispatchChange(this.elements.zoomer);
        },
        rotate: function (deg) {
            _rotate.call(this, deg);
        },
        destroy: function () {
            return _destroy.call(this);
        }
    });

    exports.Croppie = window.Croppie = Croppie;

    if (typeof module === 'object' && !!module.exports) {
        module.exports = Croppie;
    }
}));

}).call(this,require("timers").setImmediate)

},{"timers":3}],2:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(require,module,exports){
(function (setImmediate,clearImmediate){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":2,"timers":3}],4:[function(require,module,exports){

"use strict";

(function() {

    var Gator = require('../vendor/gator-1.2.4.min.js'),
        PubSub = require('../vendor/pubsub.js'),
        keyboard = require('../app/tools/keyboard.js'),

        inputFields = document.querySelectorAll('.js-keyboard-input');

    if (inputFields.length !== 0) {

        // Allow all keyboard related fields to bind the keyboard
        Gator(document.body).on('click', '.js-keyboard-input', function (e) {
            PubSub.publish(keyboard.channels.bind, e.target);
        });

        // And bind & focus on the top most field
        PubSub.publish(keyboard.channels.bind, inputFields[0]);
        inputFields[0].focus();

        // Upon hitting enter we go to the next field
        PubSub.subscribe(keyboard.channels.enter, function(){
            var i;

            // Go to the next field for all but the last field
            for (i = 0; i < inputFields.length - 1; i++) {

                if (inputFields[i] === keyboard.boundInput()) {
                    i++;
                    PubSub.publish(keyboard.channels.bind, inputFields[i]);
                    inputFields[i].focus();
                    return;
                }
            }

            // Hit enter on the last field? Then we submit the form.
            inputFields[i].form.submit();
        });


    }

}());
},{"../app/tools/keyboard.js":9,"../vendor/gator-1.2.4.min.js":12,"../vendor/pubsub.js":13}],5:[function(require,module,exports){


"use strict";

(function(){

    var feedback = document.getElementById('feedback');

    if (feedback === null) {
        return;
    }

    feedback.classList.add('fadeable');

    function fade() {
        feedback.classList.add('fade');

        setTimeout(function(){
            feedback.classList.add('hidden');
        }, 2000);
    }

    feedback.addEventListener('click', fade, false);
    setTimeout(fade, 5000);
}());

},{}],6:[function(require,module,exports){

"use strict";

(function(){

    var language_switch = document.getElementById('language-switch');


    if (language_switch === null) {
        return;
    }

    language_switch.addEventListener('click', function()
    {
        if (language_switch.classList.contains('is--active')) {
            language_switch.classList.remove('is--active');
        } else {
            language_switch.classList.add('is--active');
        }
    });



}());
},{}],7:[function(require,module,exports){
"use strict";

/**
 *
 */
(function() {

    var url, wait,
        redirect = document.getElementById('redirect-page');

    if (redirect === null) {
        return;
    }

    url = redirect.getAttribute('data-url');
    wait = redirect.getAttribute('data-wait');

    if (wait === null) {
        wait = 15000;
    } else {
        wait = parseInt(wait);
    }

    // Redirect to the starting page
    function redirectToUrl() {
        window.location.href = url;
    }

    // Redirect on touch
    document.body.addEventListener('click', redirectToUrl);

    // Auto redirect after 15 seconds
    setTimeout(redirectToUrl, wait);
}());
},{}],8:[function(require,module,exports){

"use strict";

(function() {

    var Webcam = require('../vendor/WebcamJS-1.0.25.js'),
        Croppie = require('croppie'),

        // Webcam preview
        elem = document.getElementById('webcam'),
        preview_image = document.getElementById('preview_image'),
        final_image = document.getElementById('final_image'),

        // Buttons
        start_btn = document.getElementById('start_btn'),
        retake_btn = document.getElementById('retake_btn'),
        submit_btn = document.getElementById('submit_btn'),
        back_btn = document.getElementById('back_button'),

        // Countdown & feedback
        countdown_overlay = document.getElementById('countdown_overlay'),
        upload_msg = document.getElementById('upload-msg'),
        pre_msg = document.getElementById('instruction-msg'),
        crop_msg = document.getElementById('crop-msg'),

        // Form elements
        form = document.getElementById('form'),
        file = document.getElementById('file'),

        // Internal vars
        counter,
        counterReset = 3,
        timer = null;

    // Check for the existence of all required document elements
    if (
        elem === null ||
        start_btn === null ||
        submit_btn === null ||
        retake_btn === null ||
        countdown_overlay === null ||
        preview_image === null ||
        form === null ||
        file === null
    ) {
        return;
    }

    // Try to get the counter value from the config
    if (elem.getAttribute('data-counter') !== null) {
        counterReset = parseInt(elem.getAttribute('data-counter'))
    }
    counter = counterReset;

    /**
     *
     */
    var croppie_image = new Croppie(preview_image, {
        viewport: { width: 620, height: 620 },
        boundary: { width: 720, height: 720 },
        showZoomer: false
    });

    /**
     * Note: The 3rd party WebCam script indeed has it's own freeze method.
     *       Unfortunately that one unfreezes as soon as you take a snapshot,
     *       which is necessary to obtain the base64 string we need to send to the server.
     *
     * Our custom solution uses an img overlay to show the preview.
     * Also, upon showing the preview the two buttons to either retake or accept the image are revealed.
     */
    function freeze()
    {
        Webcam.snap(function(data_uri){

            preview_image.setAttribute('src', data_uri);

            croppie_image.bind({
                url: data_uri
            });

            if (crop_msg !== null) {
                crop_msg.classList.remove('hidden');
            }

            elem.classList.add('hidden');
            preview_image.classList.remove('hidden');

            // show the follow up buttons
            retake_btn.classList.remove('hidden');
            submit_btn.classList.remove('hidden');
        });
    }

    /**
     * Hide all interface buttons.
     * This is necessary upon taking the picture (during the countdown period),
     * as well as during the uploading phase. We do not want visitors to (re)take an image at those times.
     */
    function hideAllButtons()
    {
        start_btn.classList.add('hidden');
        retake_btn.classList.add('hidden');
        submit_btn.classList.add('hidden');
    }

    /**
     * Count down from 3 to 1 before taking a shot.
     *
     * Handles showing the countdown to the visitor and takes the shot once the timer is done.
     * Also cleans things up and resets the timer.
     *
     */
    function countDown()
    {
        if (counter === 0) {

            countdown_overlay.classList.add('hidden');
            countdown_overlay.innerHTML = '';

            counter = counterReset;

            freeze();
        } else {

            countdown_overlay.innerHTML = counter;
            countdown_overlay.classList.remove('hidden');

            counter--;

            if (timer !== null) {
                clearTimeout(timer);
            }

            timer = setTimeout(countDown, 1000);
        }
    }

    /**
     * Starts the countdown
     *
     * Before doing so it clears up the interface and prepares the webcam.
     *
     * @param e
     */
    function startPictureCountDown(e)
    {
        e.preventDefault();

        hideAllButtons();

        // Upon starting the first count-down we hide the back button, if there is one
        if (back_btn !== null) {
            back_btn.classList.add('hidden');
        }

        if (pre_msg !== null) {
            pre_msg.classList.add('hidden');
        }

        // If necessary
        Webcam.unfreeze();

        preview_image.classList.add('hidden');
        elem.classList.remove('hidden');

        // Count down
        countDown();
    }

    /**
     * Upload the previewed image through the html form.
     * Show a feedback message while the image is uploading
     *
     * @param e
     */
    function upload(e)
    {
        e.preventDefault();

        hideAllButtons();

        if (crop_msg !== null) {
            crop_msg.classList.add('hidden');
        }

        if (upload_msg !== null) {
            upload_msg.classList.remove('hidden');
        }

        //on button click
        croppie_image.result('canvas').then(function(base64Image) {

            if (final_image !== null) {
                final_image.setAttribute('src', base64Image);

                preview_image.classList.add('hidden');
                final_image.classList.remove('hidden');
            }

            // There may be a maximum upload / process time before a redirect triggers
            if (
                countdown_overlay.getAttribute('data-max') !== null &&
                countdown_overlay.getAttribute('data-url') !== null
            ) {
                setTimeout(function(){
                    window.location = countdown_overlay.getAttribute('data-url');
                }, parseInt(countdown_overlay.getAttribute('data-max')) * 1000);
            }

            file.setAttribute('value', base64Image);
            form.submit();
        });
    }




    // Configure the webcam. These settings allow the use of a 720p webcam.
    Webcam.set('width', 1280);
    Webcam.set('height', 720);

    Webcam.set('crop_width', 720);
    Webcam.set('crop_height', 720);

    Webcam.set('jpeg_quality', 100);
    Webcam.set('image_format', 'jpeg'); // Expected by php

    // Mirror mode
    Webcam.set('flip_horiz', true);

    // Reveal the camera button once the webcam is ready
    Webcam.on('live', function(){

        start_btn.addEventListener('click', startPictureCountDown, false);
        start_btn.classList.remove('hidden');

        retake_btn.addEventListener('click', startPictureCountDown, false);
        submit_btn.addEventListener('click', upload, false);
    });

    // Here to avoid alert() popups
    // TODO: Rollbar integration?
    Webcam.on('error', function(err) {
      console.log("WebCam error", err)
    });

    // Kick-off
    Webcam.attach(elem);
}());
},{"../vendor/WebcamJS-1.0.25.js":11,"croppie":1}],9:[function(require,module,exports){
/*jslint white: true, browser: true, plusplus: true, todo: true */
	
/*global require: false */

/* 	Written by: 	Wouter van Dam / Britelayer
	Version:		2.0
	Creation date:	3 Oct 2014
	Updated on: 	10 May 2016
*/

"use strict";

var Gator = require('../../vendor/gator-1.2.4.min.js'),
	PubSub = require('../../vendor/pubsub.js');


(function(Gator, PubSub){
	
	var boundInput = null,
		active = false,
		capitals = 0,
		capKey = document.getElementById('caps_key'),

		keyboard = document.getElementById('keyboard'),

		// Complete list of valid key values
		keys = ['a','b','c','d','e','f','g',
			'h','i','j','k','l','m','n','o',
			'p','q','r','s','t','u','v','w',
			'x','y','z','0','1','2','3','4',
			'5','6','7','8','9',' ','&',
			'backspace', 'enter', 'numbers',
			'left', 'right', 'caps'
		],

		number_row = document.querySelector('#keyboard .zero'),

        // PubSub Channels
        channels = {
			keyboard : {
				stroke 	: 'keyboard.stroke',
				hide   	: 'keyboard.hide',
				show	: 'keyboard.show',
				bind   	: 'keyboard.bind',
				activate: 'keyboard.activate',
				enter	: 'keyboard.enter'
			}
		},

	// ------------------------------------------------------------------------
	// 	Visibility / Active state
	// ------------------------------------------------------------------------

		showKeyboard = function()
		{
			keyboard.classList.add('show');
		},
		hideKeyboard = function()
		{
			keyboard.classList.remove('show');

			if (boundInput !== null) {
				boundInput.blur();
			}
		},
		isKeyboardVisible = function()
		{
			return keyboard.classList.contains('show');
		},

		/**
		 * Depending on where the user clicked the keyboard is hidden
		 *
		 * @param event
		 */
		maybeHideKeyboard = function(event)
		{
			if (event.target == boundInput || event.target == keyboard) {
				return;
			}

			if (isKeyboardVisible()) {

				// This matches any element that is part of the keyboard html
				// Thus, any element of the keyboard does not hide the keyboard
				if (
					event.target.getAttribute('data-key') !== null ||
					event.target.classList.contains('keyboardrow') ||
					event.target.classList.contains('keyboardsmall')
				) {
					return;
				}

				hideKeyboard();
			}
		},

		/**
		 * On the first time an input element is bound the keyboard event handlers are connected to the DOM
		 */
		maybeActivate = function()
		{
			if (active === false) {
				active = true;

				// Hide the keyboard if someone clicks outside the keyboard and input area
				document.body.addEventListener('click', maybeHideKeyboard);

				// Process keystrokes
				Gator(keyboard).on('click', 'span', keyStroke);
			}
		},

	// ------------------------------------------------------------------------
	// 	Binding the Input box
	// ------------------------------------------------------------------------

		/**
		 * Check whether the passed var is an input or textarea element
		 *
		 * @param input
		 * @returns {boolean}
		 */
		isInputElement = function(input)
		{
			return input !== null &&
				typeof input === "object" &&
				"classList" in input &&
				input.nodeType === 1 &&
				(input.tagName === 'INPUT' || input.tagName === 'TEXTAREA');
		},

		/**
		 * Check whether the bound input element actually is an input element
		 *
		 * @returns {boolean}
		 */
		isInputBound = function()
		{
			return isInputElement(boundInput);
		},

		/**
		 * Bind an input element with which to interact
		 *
		 * @param input
		 */
		bindInput = function(input)
		{
			if (isInputElement(input) && input !== boundInput) {

				unbindInput();

				boundInput = input;

				// If the newly bound input box is already focused we immediately show the keyboard
				if (boundInput === document.activeElement) {
					showKeyboard();
				}

				// Activate the keyboard if this is the first bound input box
				maybeActivate();

				// Unless we're in all caps mode we capitalize the first letter
				if (capitals === 0 && input.value === '') {
					toggleCapitals(capKey);
				}

				// Show the keyboard as soon as the bound input is clicked
				boundInput.addEventListener('focus', showKeyboard);
			}
		},

		/**
		 * Clean up the event handler and clear out the input binding
		 */
		unbindInput = function()
		{
			if (isInputBound()) {
				// Disconnect
				boundInput.removeEventListener('focus', showKeyboard);
				boundInput = null;
			}
		},

		/**
		 * Return the bound input field
		 *
		 * @returns {*}
		 */
		getBoundField = function()
		{
			return boundInput;
		},




	// ------------------------------------------------------------------------
	// 	Handle Keystrokes
	// ------------------------------------------------------------------------

		/**
		 * Toggle the visibility of the number rows. This row will cover up the first row of letters
		 */
		toggleNumberRow = function(key)
		{
			if (number_row.classList.contains('hidden')) {
				key.innerText = 'ABC';
				number_row.classList.remove('hidden');
			} else {
				key.innerText = '0 - 9';
				number_row.classList.add('hidden');
			}
		},

		/**
		 * Move the cursor one position to the left
		 *
		 * @param {number} start
		 * @param {number} end
		 */
		moveLeft = function(start, end)
		{
			// If nothing is selected we move start and end
			if (start == end) {
				end = end - 1;
			}

			start = start -1;

			boundInput.focus();
			boundInput.setSelectionRange(start, end);
		},

		/**
		 * Move the cursor one position to the right
		 *
		 * @param {number} start
		 * @param {number} end
		 */
		moveRight = function(start, end)
		{

			// If nothing is selected we move start and end
			if (start == end) {
				start = start + 1;
			}

			end = end + 1;

			boundInput.focus();
			boundInput.setSelectionRange(start, end);
		},

		/**
		 * Toggle the capital flag
		 *
		 * @param key
		 */
		toggleCapitals = function(key)
		{
			capKey = key;

			// If state is caps we turn it off
			if (capitals == 2) {
				key.classList.remove('dark');
				key.innerHTML = 'shift';
				capitals = 0;
				keyboard.classList.remove('uppercase');

			// If state is shift, we go to caps
			} else if (capitals == 1) {
				key.classList.add('dark');
				key.innerHTML = 'caps';
				capitals = 2;
				keyboard.classList.add('uppercase');

			// if state is off, we go to shift
			} else {
				key.innerHTML = 'caps';
				capitals = 1;
				keyboard.classList.add('uppercase');
			}
		},


		/**
		 * Handle a keystroke on the keyboard
		 */
		keyStroke = function()
		{
			var start, end, value, pos,
				key = this.getAttribute('data-key');

			// Not a known key, then exit
			if (
				key == null ||
				-1 == keys.indexOf(key)
			) {
				return;
			}

			// ---------------------------
			//  Special characters
			// ---------------------------

			// Numbers key - toggle number row visibility
			if (key == 'numbers') {
				toggleNumberRow(this);
				return;
			}

			// Caps key - toggle capital flag
			if (key == 'caps') {
				toggleCapitals(this);
				return;
			}

			// Signal a stroke on the enter key
			if (key == 'enter') {
				PubSub.publish(channels.keyboard.enter, {});
				return;
			}

			// The rest of the keys only work with a bound input field
			if ( ! isInputBound()) {
				return;
			}

			// Get the current input value characteristics
			start 	= boundInput.selectionStart;
			end 	= boundInput.selectionEnd;
			value 	= boundInput.value;

			// Move the selected area one to the left or right
			if (key == 'left') {
				moveLeft(start, end);
				return;
			}
			if (key == 'right') {
				moveRight(start, end);
				return;
			}

			// Remove either one letter, or the selected text
			if (key == 'backspace') {

				if (start == end && start !== 0) {
					start = start - 1; // By moving the start pos one back we select the previous letter
				}
				key = '';
			}

			// ---------------------------
			//  End of special characters
			// ---------------------------

			if (capitals !== 0) {
				key = key.toUpperCase();

				// Shift = once, Caps = permanent
				if (capitals == 1) {
					capitals = 0;
					keyboard.classList.remove('uppercase');
					if (capKey !== null) {
						capKey.innerHTML = 'shift';
					}
				}
			}

			// update input value
			boundInput.value = value.substring(0, start) + key + value.substring(end);
			boundInput.focus();

			// Move the cursor to the position behind the value we just added
			if (start !== 0) {
				pos = start + key.length;
				boundInput.setSelectionRange(pos, pos);
			}

			// Notify the world that we registered a keystroke that changed the input value
			PubSub.publish(channels.keyboard.stroke, {
				key: key,
				newValue: boundInput.value,
				oldValue: value
			});
		};


	// ------------------------------------------------------------------------
	// 	Subscribe to external signals
	// ------------------------------------------------------------------------

	// Only subscribe to signals if we have a keyboard to work with...
	if (keyboard !== null) {

		// We start with a capital key
		toggleCapitals(capKey);

		// Capture signals to bind the keyboard to an input field
		PubSub.subscribe(channels.keyboard.bind, bindInput);

		// Capture external signals to hide the keyboard
		PubSub.subscribe(channels.keyboard.hide, hideKeyboard);

		// Capture external signals to show the keyboard
		PubSub.subscribe(channels.keyboard.show, showKeyboard);

		// Allow an external script to activate the keyboard early
		PubSub.subscribe(channels.keyboard.activate, maybeActivate);
	}

	// ------------------------------------------------------------------------
	// 	The API
	// ------------------------------------------------------------------------

	// Export the pubsub channels
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = {
			channels  	 : channels.keyboard,
			boundInput 	 : getBoundField
		};
	}

}(Gator, PubSub));


},{"../../vendor/gator-1.2.4.min.js":12,"../../vendor/pubsub.js":13}],10:[function(require,module,exports){

(function() {

    require('./app/language_switch.js');
    require('./app/data_forms.js');
    require('./app/take_picture.js');
    require('./app/feedback.js');
    require('./app/redirect_page.js');
}());
},{"./app/data_forms.js":4,"./app/feedback.js":5,"./app/language_switch.js":6,"./app/redirect_page.js":7,"./app/take_picture.js":8}],11:[function(require,module,exports){
// WebcamJS v1.0.25
// Webcam library for capturing JPEG/PNG images in JavaScript
// Attempts getUserMedia, falls back to Flash
// Author: Joseph Huckaby: http://github.com/jhuckaby
// Based on JPEGCam: http://code.google.com/p/jpegcam/
// Copyright (c) 2012 - 2017 Joseph Huckaby
// Licensed under the MIT License

(function(window) {
  var _userMedia;
  
  // declare error types
  
  // inheritance pattern here:
  // https://stackoverflow.com/questions/783818/how-do-i-create-a-custom-error-in-javascript
  function FlashError() {
    var temp = Error.apply(this, arguments);
    temp.name = this.name = "FlashError";
    this.stack = temp.stack;
    this.message = temp.message;
  }
  
  function WebcamError() {
    var temp = Error.apply(this, arguments);
    temp.name = this.name = "WebcamError";
    this.stack = temp.stack;
    this.message = temp.message;
  }
  
  var IntermediateInheritor = function() {};
  IntermediateInheritor.prototype = Error.prototype;
  
  FlashError.prototype = new IntermediateInheritor();
  WebcamError.prototype = new IntermediateInheritor();
  
  var Webcam = {
    version: '1.0.25',
    
    // globals
    protocol: location.protocol.match(/https/i) ? 'https' : 'http',
    loaded: false,   // true when webcam movie finishes loading
    live: false,     // true when webcam is initialized and ready to snap
    userMedia: true, // true when getUserMedia is supported natively
  
    iOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
  
    params: {
      width: 0,
      height: 0,
      dest_width: 0,         // size of captured image
      dest_height: 0,        // these default to width/height
      image_format: 'jpeg',  // image format (may be jpeg or png)
      jpeg_quality: 90,      // jpeg image quality from 0 (worst) to 100 (best)
      enable_flash: true,    // enable flash fallback,
      force_flash: false,    // force flash mode,
      flip_horiz: false,     // flip image horiz (mirror mode)
      fps: 30,               // camera frames per second
      upload_name: 'webcam', // name of file in upload post data
      constraints: null,     // custom user media constraints,
      swfURL: '',            // URI to webcam.swf movie (defaults to the js location)
      flashNotDetectedText: 'ERROR: No Adobe Flash Player detected.  Webcam.js relies on Flash for browsers that do not support getUserMedia (like yours).',
      noInterfaceFoundText: 'No supported webcam interface found.',
      unfreeze_snap: true,    // Whether to unfreeze the camera after snap (defaults to true)
      iosPlaceholderText: 'Click here to open camera.',
      user_callback: null,    // callback function for snapshot (used if no user_callback parameter given to snap function)
      user_canvas: null       // user provided canvas for snapshot (used if no user_canvas parameter given to snap function)
    },
  
    errors: {
      FlashError: FlashError,
      WebcamError: WebcamError
    },
    
    hooks: {}, // callback hook functions
    
    init: function() {
      // initialize, check for getUserMedia support
      var self = this;
      
      // Setup getUserMedia, with polyfill for older browsers
      // Adapted from: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
      this.mediaDevices = (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ? 
        navigator.mediaDevices : ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? {
          getUserMedia: function(c) {
            return new Promise(function(y, n) {
              (navigator.mozGetUserMedia ||
              navigator.webkitGetUserMedia).call(navigator, c, y, n);
            });
          }
      } : null);
      
      window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
      this.userMedia = this.userMedia && !!this.mediaDevices && !!window.URL;
      
      if (this.iOS) {
        this.userMedia = null;
      }
      
      // Older versions of firefox (< 21) apparently claim support but user media does not actually work
      if (navigator.userAgent.match(/Firefox\D+(\d+)/)) {
        if (parseInt(RegExp.$1, 10) < 21) this.userMedia = null;
      }
      
      // Make sure media stream is closed when navigating away from page
      if (this.userMedia) {
        window.addEventListener( 'beforeunload', function(event) {
          self.reset();
        } );
      }
    },
    
    exifOrientation: function(binFile) {
      // extract orientation information from the image provided by iOS
      // algorithm based on exif-js
      var dataView = new DataView(binFile);
      if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
        console.log('Not a valid JPEG file');
        return 0;
      }
      var offset = 2;
      var marker = null;
      while (offset < binFile.byteLength) {
        // find 0xFFE1 (225 marker)
        if (dataView.getUint8(offset) != 0xFF) {
          console.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
          return 0;
        }
        marker = dataView.getUint8(offset + 1);
        if (marker == 225) {
          offset += 4;
          var str = "";
          for (n = 0; n < 4; n++) {
            str += String.fromCharCode(dataView.getUint8(offset+n));
          }
          if (str != 'Exif') {
            console.log('Not valid EXIF data found');
            return 0;
          }
          
          offset += 6; // tiffOffset
          var bigEnd = null;
  
          // test for TIFF validity and endianness
          if (dataView.getUint16(offset) == 0x4949) {
            bigEnd = false;
          } else if (dataView.getUint16(offset) == 0x4D4D) {
            bigEnd = true;
          } else {
            console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return 0;
          }
  
          if (dataView.getUint16(offset+2, !bigEnd) != 0x002A) {
            console.log("Not valid TIFF data! (no 0x002A)");
            return 0;
          }
  
          var firstIFDOffset = dataView.getUint32(offset+4, !bigEnd);
          if (firstIFDOffset < 0x00000008) {
            console.log("Not valid TIFF data! (First offset less than 8)", dataView.getUint32(offset+4, !bigEnd));
            return 0;
          }
  
          // extract orientation data
          var dataStart = offset + firstIFDOffset;
          var entries = dataView.getUint16(dataStart, !bigEnd);
          for (var i=0; i<entries; i++) {
            var entryOffset = dataStart + i*12 + 2;
            if (dataView.getUint16(entryOffset, !bigEnd) == 0x0112) {
              var valueType = dataView.getUint16(entryOffset+2, !bigEnd);
              var numValues = dataView.getUint32(entryOffset+4, !bigEnd);
              if (valueType != 3 && numValues != 1) {
                console.log('Invalid EXIF orientation value type ('+valueType+') or count ('+numValues+')');
                return 0;
              }
              var value = dataView.getUint16(entryOffset + 8, !bigEnd);
              if (value < 1 || value > 8) {
                console.log('Invalid EXIF orientation value ('+value+')');
                return 0;
              }
              return value;
            }
          }
        } else {
          offset += 2+dataView.getUint16(offset+2);
        }
      }
      return 0;
    },
    
    fixOrientation: function(origObjURL, orientation, targetImg) {
      // fix image orientation based on exif orientation data
      // exif orientation information
      //    http://www.impulseadventure.com/photo/exif-orientation.html
      //    link source wikipedia (https://en.wikipedia.org/wiki/Exif#cite_note-20)
      var img = new Image();
      img.addEventListener('load', function(event) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        
        // switch width height if orientation needed
        if (orientation < 5) {
          canvas.width = img.width;
          canvas.height = img.height;
        } else {
          canvas.width = img.height;
          canvas.height = img.width;
        }
  
        // transform (rotate) image - see link at beginning this method
        switch (orientation) {
          case 2: ctx.transform(-1, 0, 0, 1, img.width, 0); break;
          case 3: ctx.transform(-1, 0, 0, -1, img.width, img.height); break;
          case 4: ctx.transform(1, 0, 0, -1, 0, img.height); break;
          case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
          case 6: ctx.transform(0, 1, -1, 0, img.height , 0); break;
          case 7: ctx.transform(0, -1, -1, 0, img.height, img.width); break;
          case 8: ctx.transform(0, -1, 1, 0, 0, img.width); break;
        }
  
        ctx.drawImage(img, 0, 0);
        // pass rotated image data to the target image container
        targetImg.src = canvas.toDataURL();
      }, false);
      // start transformation by load event
      img.src = origObjURL;
    },
    
    attach: function(elem) {
      // create webcam preview and attach to DOM element
      // pass in actual DOM reference, ID, or CSS selector
      if (typeof(elem) == 'string') {
        elem = document.getElementById(elem) || document.querySelector(elem);
      }
      if (!elem) {
        return this.dispatch('error', new WebcamError("Could not locate DOM element to attach to."));
      }
      this.container = elem;
      elem.innerHTML = ''; // start with empty element
      
      // insert "peg" so we can insert our preview canvas adjacent to it later on
      var peg = document.createElement('div');
      elem.appendChild( peg );
      this.peg = peg;
      
      // set width/height if not already set
      if (!this.params.width) this.params.width = elem.offsetWidth;
      if (!this.params.height) this.params.height = elem.offsetHeight;
      
      // make sure we have a nonzero width and height at this point
      if (!this.params.width || !this.params.height) {
        return this.dispatch('error', new WebcamError("No width and/or height for webcam.  Please call set() first, or attach to a visible element."));
      }
      
      // set defaults for dest_width / dest_height if not set
      if (!this.params.dest_width) this.params.dest_width = this.params.width;
      if (!this.params.dest_height) this.params.dest_height = this.params.height;
      
      this.userMedia = _userMedia === undefined ? this.userMedia : _userMedia;
      // if force_flash is set, disable userMedia
      if (this.params.force_flash) {
        _userMedia = this.userMedia;
        this.userMedia = null;
      }
      
      // check for default fps
      if (typeof this.params.fps !== "number") this.params.fps = 30;
  
      // adjust scale if dest_width or dest_height is different
      var scaleX = this.params.width / this.params.dest_width;
      var scaleY = this.params.height / this.params.dest_height;
      
      if (this.userMedia) {
        // setup webcam video container
        var video = document.createElement('video');
        video.setAttribute('autoplay', 'autoplay');
        video.style.width = '' + this.params.dest_width + 'px';
        video.style.height = '' + this.params.dest_height + 'px';
        
        if ((scaleX != 1.0) || (scaleY != 1.0)) {
          elem.style.overflow = 'hidden';
          video.style.webkitTransformOrigin = '0px 0px';
          video.style.mozTransformOrigin = '0px 0px';
          video.style.msTransformOrigin = '0px 0px';
          video.style.oTransformOrigin = '0px 0px';
          video.style.transformOrigin = '0px 0px';
          video.style.webkitTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
          video.style.mozTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
          video.style.msTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
          video.style.oTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
          video.style.transform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
        }
        
        // add video element to dom
        elem.appendChild( video );
        this.video = video;
        
        // ask user for access to their camera
        var self = this;
        this.mediaDevices.getUserMedia({
          "audio": false,
          "video": this.params.constraints || {
            mandatory: {
              minWidth: this.params.dest_width,
              minHeight: this.params.dest_height
            }
          }
        })
        .then( function(stream) {
          // got access, attach stream to video
          video.onloadedmetadata = function(e) {
            self.stream = stream;
            self.loaded = true;
            self.live = true;
            self.dispatch('load');
            self.dispatch('live');
            self.flip();
          };
          // as window.URL.createObjectURL() is deprecated, adding a check so that it works in Safari.
          // older browsers may not have srcObject
          if ("srcObject" in video) {
              video.srcObject = stream;
          }
          else {
              // using URL.createObjectURL() as fallback for old browsers
              video.src = window.URL.createObjectURL(stream);
          }
        })
        .catch( function(err) {
          // JH 2016-07-31 Instead of dispatching error, now falling back to Flash if userMedia fails (thx @john2014)
          // JH 2016-08-07 But only if flash is actually installed -- if not, dispatch error here and now.
          if (self.params.enable_flash && self.detectFlash()) {
            setTimeout( function() { self.params.force_flash = 1; self.attach(elem); }, 1 );
          }
          else {
            self.dispatch('error', err);
          }
        });
      }
      else if (this.iOS) {
        // prepare HTML elements
        var div = document.createElement('div');
        div.id = this.container.id+'-ios_div';
        div.className = 'webcamjs-ios-placeholder';
        div.style.width = '' + this.params.width + 'px';
        div.style.height = '' + this.params.height + 'px';
        div.style.textAlign = 'center';
        div.style.display = 'table-cell';
        div.style.verticalAlign = 'middle';
        div.style.backgroundRepeat = 'no-repeat';
        div.style.backgroundSize = 'contain';
        div.style.backgroundPosition = 'center';
        var span = document.createElement('span');
        span.className = 'webcamjs-ios-text';
        span.innerHTML = this.params.iosPlaceholderText;
        div.appendChild(span);
        var img = document.createElement('img');
        img.id = this.container.id+'-ios_img';
        img.style.width = '' + this.params.dest_width + 'px';
        img.style.height = '' + this.params.dest_height + 'px';
        img.style.display = 'none';
        div.appendChild(img);
        var input = document.createElement('input');
        input.id = this.container.id+'-ios_input';
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.setAttribute('capture', 'camera');
        
        var self = this;
        var params = this.params;
        // add input listener to load the selected image
        input.addEventListener('change', function(event) {
          if (event.target.files.length > 0 && event.target.files[0].type.indexOf('image/') == 0) {
            var objURL = URL.createObjectURL(event.target.files[0]);
  
            // load image with auto scale and crop
            var image = new Image();
            image.addEventListener('load', function(event) {
              var canvas = document.createElement('canvas');
              canvas.width = params.dest_width;
              canvas.height = params.dest_height;
              var ctx = canvas.getContext('2d');
  
              // crop and scale image for final size
              ratio = Math.min(image.width / params.dest_width, image.height / params.dest_height);
              var sw = params.dest_width * ratio;
              var sh = params.dest_height * ratio;
              var sx = (image.width - sw) / 2;
              var sy = (image.height - sh) / 2;
              ctx.drawImage(image, sx, sy, sw, sh, 0, 0, params.dest_width, params.dest_height);
  
              var dataURL = canvas.toDataURL();
              img.src = dataURL;
              div.style.backgroundImage = "url('"+dataURL+"')";
            }, false);
            
            // read EXIF data
            var fileReader = new FileReader();
            fileReader.addEventListener('load', function(e) {
              var orientation = self.exifOrientation(e.target.result);
              if (orientation > 1) {
                // image need to rotate (see comments on fixOrientation method for more information)
                // transform image and load to image object
                self.fixOrientation(objURL, orientation, image);
              } else {
                // load image data to image object
                image.src = objURL;
              }
            }, false);
            
            // Convert image data to blob format
            var http = new XMLHttpRequest();
            http.open("GET", objURL, true);
            http.responseType = "blob";
            http.onload = function(e) {
              if (this.status == 200 || this.status === 0) {
                fileReader.readAsArrayBuffer(this.response);
              }
            };
            http.send();
  
          }
        }, false);
        input.style.display = 'none';
        elem.appendChild(input);
        // make div clickable for open camera interface
        div.addEventListener('click', function(event) {
          if (params.user_callback) {
            // global user_callback defined - create the snapshot
            self.snap(params.user_callback, params.user_canvas);
          } else {
            // no global callback definied for snapshot, load image and wait for external snap method call
            input.style.display = 'block';
            input.focus();
            input.click();
            input.style.display = 'none';
          }
        }, false);
        elem.appendChild(div);
        this.loaded = true;
        this.live = true;
      }
      else if (this.params.enable_flash && this.detectFlash()) {
        // flash fallback
        window.Webcam = Webcam; // needed for flash-to-js interface
        var div = document.createElement('div');
        div.innerHTML = this.getSWFHTML();
        elem.appendChild( div );
      }
      else {
        this.dispatch('error', new WebcamError( this.params.noInterfaceFoundText ));
      }
      
      // setup final crop for live preview
      if (this.params.crop_width && this.params.crop_height) {
        var scaled_crop_width = Math.floor( this.params.crop_width * scaleX );
        var scaled_crop_height = Math.floor( this.params.crop_height * scaleY );
        
        elem.style.width = '' + scaled_crop_width + 'px';
        elem.style.height = '' + scaled_crop_height + 'px';
        elem.style.overflow = 'hidden';
        
        elem.scrollLeft = Math.floor( (this.params.width / 2) - (scaled_crop_width / 2) );
        elem.scrollTop = Math.floor( (this.params.height / 2) - (scaled_crop_height / 2) );
      }
      else {
        // no crop, set size to desired
        elem.style.width = '' + this.params.width + 'px';
        elem.style.height = '' + this.params.height + 'px';
      }
    },
    
    reset: function() {
      // shutdown camera, reset to potentially attach again
      if (this.preview_active) this.unfreeze();
      
      // attempt to fix issue #64
      this.unflip();
      
      if (this.userMedia) {
        if (this.stream) {
          if (this.stream.getVideoTracks) {
            // get video track to call stop on it
            var tracks = this.stream.getVideoTracks();
            if (tracks && tracks[0] && tracks[0].stop) tracks[0].stop();
          }
          else if (this.stream.stop) {
            // deprecated, may be removed in future
            this.stream.stop();
          }
        }
        delete this.stream;
        delete this.video;
      }
  
      if ((this.userMedia !== true) && this.loaded && !this.iOS) {
        // call for turn off camera in flash
        var movie = this.getMovie();
        if (movie && movie._releaseCamera) movie._releaseCamera();
      }
  
      if (this.container) {
        this.container.innerHTML = '';
        delete this.container;
      }
    
      this.loaded = false;
      this.live = false;
    },
    
    set: function() {
      // set one or more params
      // variable argument list: 1 param = hash, 2 params = key, value
      if (arguments.length == 1) {
        for (var key in arguments[0]) {
          this.params[key] = arguments[0][key];
        }
      }
      else {
        this.params[ arguments[0] ] = arguments[1];
      }
    },
    
    on: function(name, callback) {
      // set callback hook
      name = name.replace(/^on/i, '').toLowerCase();
      if (!this.hooks[name]) this.hooks[name] = [];
      this.hooks[name].push( callback );
    },
    
    off: function(name, callback) {
      // remove callback hook
      name = name.replace(/^on/i, '').toLowerCase();
      if (this.hooks[name]) {
        if (callback) {
          // remove one selected callback from list
          var idx = this.hooks[name].indexOf(callback);
          if (idx > -1) this.hooks[name].splice(idx, 1);
        }
        else {
          // no callback specified, so clear all
          this.hooks[name] = [];
        }
      }
    },
    
    dispatch: function() {
      // fire hook callback, passing optional value to it
      var name = arguments[0].replace(/^on/i, '').toLowerCase();
      var args = Array.prototype.slice.call(arguments, 1);
      
      if (this.hooks[name] && this.hooks[name].length) {
        for (var idx = 0, len = this.hooks[name].length; idx < len; idx++) {
          var hook = this.hooks[name][idx];
          
          if (typeof(hook) == 'function') {
            // callback is function reference, call directly
            hook.apply(this, args);
          }
          else if ((typeof(hook) == 'object') && (hook.length == 2)) {
            // callback is PHP-style object instance method
            hook[0][hook[1]].apply(hook[0], args);
          }
          else if (window[hook]) {
            // callback is global function name
            window[ hook ].apply(window, args);
          }
        } // loop
        return true;
      }
      else if (name == 'error') {
        var message;
        if ((args[0] instanceof FlashError) || (args[0] instanceof WebcamError)) {
          message = args[0].message;
        } else {
          message = "Could not access webcam: " + args[0].name + ": " + 
            args[0].message + " " + args[0].toString();
        }
  
        // default error handler if no custom one specified
        alert("Webcam.js Error: " + message);
      }
      
      return false; // no hook defined
    },
  
    setSWFLocation: function(value) {
      // for backward compatibility.
      this.set('swfURL', value);
    },
    
    detectFlash: function() {
      // return true if browser supports flash, false otherwise
      // Code snippet borrowed from: https://github.com/swfobject/swfobject
      var SHOCKWAVE_FLASH = "Shockwave Flash",
        SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash",
            FLASH_MIME_TYPE = "application/x-shockwave-flash",
            win = window,
            nav = navigator,
            hasFlash = false;
          
          if (typeof nav.plugins !== "undefined" && typeof nav.plugins[SHOCKWAVE_FLASH] === "object") {
            var desc = nav.plugins[SHOCKWAVE_FLASH].description;
            if (desc && (typeof nav.mimeTypes !== "undefined" && nav.mimeTypes[FLASH_MIME_TYPE] && nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) {
              hasFlash = true;
            }
          }
          else if (typeof win.ActiveXObject !== "undefined") {
            try {
              var ax = new ActiveXObject(SHOCKWAVE_FLASH_AX);
              if (ax) {
                var ver = ax.GetVariable("$version");
                if (ver) hasFlash = true;
              }
            }
            catch (e) {;}
          }
          
          return hasFlash;
    },
    
    getSWFHTML: function() {
      // Return HTML for embedding flash based webcam capture movie		
      var html = '',
        swfURL = this.params.swfURL;
      
      // make sure we aren't running locally (flash doesn't work)
      if (location.protocol.match(/file/)) {
        this.dispatch('error', new FlashError("Flash does not work from local disk.  Please run from a web server."));
        return '<h3 style="color:red">ERROR: the Webcam.js Flash fallback does not work from local disk.  Please run it from a web server.</h3>';
      }
      
      // make sure we have flash
      if (!this.detectFlash()) {
        this.dispatch('error', new FlashError("Adobe Flash Player not found.  Please install from get.adobe.com/flashplayer and try again."));
        return '<h3 style="color:red">' + this.params.flashNotDetectedText + '</h3>';
      }
      
      // set default swfURL if not explicitly set
      if (!swfURL) {
        // find our script tag, and use that base URL
        var base_url = '';
        var scpts = document.getElementsByTagName('script');
        for (var idx = 0, len = scpts.length; idx < len; idx++) {
          var src = scpts[idx].getAttribute('src');
          if (src && src.match(/\/webcam(\.min)?\.js/)) {
            base_url = src.replace(/\/webcam(\.min)?\.js.*$/, '');
            idx = len;
          }
        }
        if (base_url) swfURL = base_url + '/webcam.swf';
        else swfURL = 'webcam.swf';
      }
      
      // if this is the user's first visit, set flashvar so flash privacy settings panel is shown first
      if (window.localStorage && !localStorage.getItem('visited')) {
        this.params.new_user = 1;
        localStorage.setItem('visited', 1);
      }
      
      // construct flashvars string
      var flashvars = '';
      for (var key in this.params) {
        if (flashvars) flashvars += '&';
        flashvars += key + '=' + escape(this.params[key]);
      }
      
      // construct object/embed tag
      html += '<object classid="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" type="application/x-shockwave-flash" codebase="'+this.protocol+'://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=9,0,0,0" width="'+this.params.width+'" height="'+this.params.height+'" id="webcam_movie_obj" align="middle"><param name="wmode" value="opaque" /><param name="allowScriptAccess" value="always" /><param name="allowFullScreen" value="false" /><param name="movie" value="'+swfURL+'" /><param name="loop" value="false" /><param name="menu" value="false" /><param name="quality" value="best" /><param name="bgcolor" value="#ffffff" /><param name="flashvars" value="'+flashvars+'"/><embed id="webcam_movie_embed" src="'+swfURL+'" wmode="opaque" loop="false" menu="false" quality="best" bgcolor="#ffffff" width="'+this.params.width+'" height="'+this.params.height+'" name="webcam_movie_embed" align="middle" allowScriptAccess="always" allowFullScreen="false" type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" flashvars="'+flashvars+'"></embed></object>';
      
      return html;
    },
    
    getMovie: function() {
      // get reference to movie object/embed in DOM
      if (!this.loaded) return this.dispatch('error', new FlashError("Flash Movie is not loaded yet"));
      var movie = document.getElementById('webcam_movie_obj');
      if (!movie || !movie._snap) movie = document.getElementById('webcam_movie_embed');
      if (!movie) this.dispatch('error', new FlashError("Cannot locate Flash movie in DOM"));
      return movie;
    },
    
    freeze: function() {
      // show preview, freeze camera
      var self = this;
      var params = this.params;
      
      // kill preview if already active
      if (this.preview_active) this.unfreeze();
      
      // determine scale factor
      var scaleX = this.params.width / this.params.dest_width;
      var scaleY = this.params.height / this.params.dest_height;
      
      // must unflip container as preview canvas will be pre-flipped
      this.unflip();
      
      // calc final size of image
      var final_width = params.crop_width || params.dest_width;
      var final_height = params.crop_height || params.dest_height;
      
      // create canvas for holding preview
      var preview_canvas = document.createElement('canvas');
      preview_canvas.width = final_width;
      preview_canvas.height = final_height;
      var preview_context = preview_canvas.getContext('2d');
      
      // save for later use
      this.preview_canvas = preview_canvas;
      this.preview_context = preview_context;
      
      // scale for preview size
      if ((scaleX != 1.0) || (scaleY != 1.0)) {
        preview_canvas.style.webkitTransformOrigin = '0px 0px';
        preview_canvas.style.mozTransformOrigin = '0px 0px';
        preview_canvas.style.msTransformOrigin = '0px 0px';
        preview_canvas.style.oTransformOrigin = '0px 0px';
        preview_canvas.style.transformOrigin = '0px 0px';
        preview_canvas.style.webkitTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
        preview_canvas.style.mozTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
        preview_canvas.style.msTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
        preview_canvas.style.oTransform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
        preview_canvas.style.transform = 'scaleX('+scaleX+') scaleY('+scaleY+')';
      }
      
      // take snapshot, but fire our own callback
      this.snap( function() {
        // add preview image to dom, adjust for crop
        preview_canvas.style.position = 'relative';
        preview_canvas.style.left = '' + self.container.scrollLeft + 'px';
        preview_canvas.style.top = '' + self.container.scrollTop + 'px';
        
        self.container.insertBefore( preview_canvas, self.peg );
        self.container.style.overflow = 'hidden';
        
        // set flag for user capture (use preview)
        self.preview_active = true;
        
      }, preview_canvas );
    },
    
    unfreeze: function() {
      // cancel preview and resume live video feed
      if (this.preview_active) {
        // remove preview canvas
        this.container.removeChild( this.preview_canvas );
        delete this.preview_context;
        delete this.preview_canvas;
        
        // unflag
        this.preview_active = false;
        
        // re-flip if we unflipped before
        this.flip();
      }
    },
    
    flip: function() {
      // flip container horiz (mirror mode) if desired
      if (this.params.flip_horiz) {
        var sty = this.container.style;
        sty.webkitTransform = 'scaleX(-1)';
        sty.mozTransform = 'scaleX(-1)';
        sty.msTransform = 'scaleX(-1)';
        sty.oTransform = 'scaleX(-1)';
        sty.transform = 'scaleX(-1)';
        sty.filter = 'FlipH';
        sty.msFilter = 'FlipH';
      }
    },
    
    unflip: function() {
      // unflip container horiz (mirror mode) if desired
      if (this.params.flip_horiz) {
        var sty = this.container.style;
        sty.webkitTransform = 'scaleX(1)';
        sty.mozTransform = 'scaleX(1)';
        sty.msTransform = 'scaleX(1)';
        sty.oTransform = 'scaleX(1)';
        sty.transform = 'scaleX(1)';
        sty.filter = '';
        sty.msFilter = '';
      }
    },
    
    savePreview: function(user_callback, user_canvas) {
      // save preview freeze and fire user callback
      var params = this.params;
      var canvas = this.preview_canvas;
      var context = this.preview_context;
      
      // render to user canvas if desired
      if (user_canvas) {
        var user_context = user_canvas.getContext('2d');
        user_context.drawImage( canvas, 0, 0 );
      }
      
      // fire user callback if desired
      user_callback(
        user_canvas ? null : canvas.toDataURL('image/' + params.image_format, params.jpeg_quality / 100 ),
        canvas,
        context
      );
      
      // remove preview
      if (this.params.unfreeze_snap) this.unfreeze();
    },
    
    snap: function(user_callback, user_canvas) {
      // use global callback and canvas if not defined as parameter
      if (!user_callback) user_callback = this.params.user_callback;
      if (!user_canvas) user_canvas = this.params.user_canvas;
      
      // take snapshot and return image data uri
      var self = this;
      var params = this.params;
      
      if (!this.loaded) return this.dispatch('error', new WebcamError("Webcam is not loaded yet"));
      // if (!this.live) return this.dispatch('error', new WebcamError("Webcam is not live yet"));
      if (!user_callback) return this.dispatch('error', new WebcamError("Please provide a callback function or canvas to snap()"));
      
      // if we have an active preview freeze, use that
      if (this.preview_active) {
        this.savePreview( user_callback, user_canvas );
        return null;
      }
      
      // create offscreen canvas element to hold pixels
      var canvas = document.createElement('canvas');
      canvas.width = this.params.dest_width;
      canvas.height = this.params.dest_height;
      var context = canvas.getContext('2d');
      
      // flip canvas horizontally if desired
      if (this.params.flip_horiz) {
        context.translate( params.dest_width, 0 );
        context.scale( -1, 1 );
      }
      
      // create inline function, called after image load (flash) or immediately (native)
      var func = function() {
        // render image if needed (flash)
        if (this.src && this.width && this.height) {
          context.drawImage(this, 0, 0, params.dest_width, params.dest_height);
        }
        
        // crop if desired
        if (params.crop_width && params.crop_height) {
          var crop_canvas = document.createElement('canvas');
          crop_canvas.width = params.crop_width;
          crop_canvas.height = params.crop_height;
          var crop_context = crop_canvas.getContext('2d');
          
          crop_context.drawImage( canvas, 
            Math.floor( (params.dest_width / 2) - (params.crop_width / 2) ),
            Math.floor( (params.dest_height / 2) - (params.crop_height / 2) ),
            params.crop_width,
            params.crop_height,
            0,
            0,
            params.crop_width,
            params.crop_height
          );
          
          // swap canvases
          context = crop_context;
          canvas = crop_canvas;
        }
        
        // render to user canvas if desired
        if (user_canvas) {
          var user_context = user_canvas.getContext('2d');
          user_context.drawImage( canvas, 0, 0 );
        }
        
        // fire user callback if desired
        user_callback(
          user_canvas ? null : canvas.toDataURL('image/' + params.image_format, params.jpeg_quality / 100 ),
          canvas,
          context
        );
      };
      
      // grab image frame from userMedia or flash movie
      if (this.userMedia) {
        // native implementation
        context.drawImage(this.video, 0, 0, this.params.dest_width, this.params.dest_height);
        
        // fire callback right away
        func();
      }
      else if (this.iOS) {
        var div = document.getElementById(this.container.id+'-ios_div');
        var img = document.getElementById(this.container.id+'-ios_img');
        var input = document.getElementById(this.container.id+'-ios_input');
        // function for handle snapshot event (call user_callback and reset the interface)
        iFunc = function(event) {
          func.call(img);
          img.removeEventListener('load', iFunc);
          div.style.backgroundImage = 'none';
          img.removeAttribute('src');
          input.value = null;
        };
        if (!input.value) {
          // No image selected yet, activate input field
          img.addEventListener('load', iFunc);
          input.style.display = 'block';
          input.focus();
          input.click();
          input.style.display = 'none';
        } else {
          // Image already selected
          iFunc(null);
        }			
      }
      else {
        // flash fallback
        var raw_data = this.getMovie()._snap();
        
        // render to image, fire callback when complete
        var img = new Image();
        img.onload = func;
        img.src = 'data:image/'+this.params.image_format+';base64,' + raw_data;
      }
      
      return null;
    },
    
    configure: function(panel) {
      // open flash configuration panel -- specify tab name:
      // "camera", "privacy", "default", "localStorage", "microphone", "settingsManager"
      if (!panel) panel = "camera";
      this.getMovie()._configure(panel);
    },
    
    flashNotify: function(type, msg) {
      // receive notification from flash about event
      switch (type) {
        case 'flashLoadComplete':
          // movie loaded successfully
          this.loaded = true;
          this.dispatch('load');
          break;
        
        case 'cameraLive':
          // camera is live and ready to snap
          this.live = true;
          this.dispatch('live');
          break;
  
        case 'error':
          // Flash error
          this.dispatch('error', new FlashError(msg));
          break;
  
        default:
          // catch-all event, just in case
          // console.log("webcam flash_notify: " + type + ": " + msg);
          break;
      }
    },
    
    b64ToUint6: function(nChr) {
      // convert base64 encoded character to 6-bit integer
      // from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Base64_encoding_and_decoding
      return nChr > 64 && nChr < 91 ? nChr - 65
        : nChr > 96 && nChr < 123 ? nChr - 71
        : nChr > 47 && nChr < 58 ? nChr + 4
        : nChr === 43 ? 62 : nChr === 47 ? 63 : 0;
    },
  
    base64DecToArr: function(sBase64, nBlocksSize) {
      // convert base64 encoded string to Uintarray
      // from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Base64_encoding_and_decoding
      var sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, ""), nInLen = sB64Enc.length,
        nOutLen = nBlocksSize ? Math.ceil((nInLen * 3 + 1 >> 2) / nBlocksSize) * nBlocksSize : nInLen * 3 + 1 >> 2, 
        taBytes = new Uint8Array(nOutLen);
      
      for (var nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
        nMod4 = nInIdx & 3;
        nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
        if (nMod4 === 3 || nInLen - nInIdx === 1) {
          for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
            taBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
          }
          nUint24 = 0;
        }
      }
      return taBytes;
    },
    
    upload: function(image_data_uri, target_url, callback) {
      // submit image data to server using binary AJAX
      var form_elem_name = this.params.upload_name || 'webcam';
      
      // detect image format from within image_data_uri
      var image_fmt = '';
      if (image_data_uri.match(/^data\:image\/(\w+)/))
        image_fmt = RegExp.$1;
      else
        throw "Cannot locate image format in Data URI";
      
      // extract raw base64 data from Data URI
      var raw_image_data = image_data_uri.replace(/^data\:image\/\w+\;base64\,/, '');
      
      // contruct use AJAX object
      var http = new XMLHttpRequest();
      http.open("POST", target_url, true);
      
      // setup progress events
      if (http.upload && http.upload.addEventListener) {
        http.upload.addEventListener( 'progress', function(e) {
          if (e.lengthComputable) {
            var progress = e.loaded / e.total;
            Webcam.dispatch('uploadProgress', progress, e);
          }
        }, false );
      }
      
      // completion handler
      var self = this;
      http.onload = function() {
        if (callback) callback.apply( self, [http.status, http.responseText, http.statusText] );
        Webcam.dispatch('uploadComplete', http.status, http.responseText, http.statusText);
      };
      
      // create a blob and decode our base64 to binary
      var blob = new Blob( [ this.base64DecToArr(raw_image_data) ], {type: 'image/'+image_fmt} );
      
      // stuff into a form, so servers can easily receive it as a standard file upload
      var form = new FormData();
      form.append( form_elem_name, blob, form_elem_name+"."+image_fmt.replace(/e/, '') );
      
      // send data to server
      http.send(form);
    }
    
  };
  
  Webcam.init();
  
  if (typeof define === 'function' && define.amd) {
    define( function() { return Webcam; } );
  } 
  else if (typeof module === 'object' && module.exports) {
    module.exports = Webcam;
  } 
  else {
    window.Webcam = Webcam;
  }
  
  }(window));
},{}],12:[function(require,module,exports){
/**
 * Copyright 2014 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * GATOR.JS
 * Simple Event Delegation
 *
 * @version 1.2.4
 *
 * Compatible with IE 9+, FF 3.6+, Safari 5+, Chrome
 *
 * Include legacy.js for compatibility with older browsers
 *
 *             .-._   _ _ _ _ _ _ _ _
 *  .-''-.__.-'00  '-' ' ' ' ' ' ' ' '-.
 * '.___ '    .   .--_'-' '-' '-' _'-' '._
 *  V: V 'vv-'   '_   '.       .'  _..' '.'.
 *    '=.____.=_.--'   :_.__.__:_   '.   : :
 *            (((____.-'        '-.  /   : :
 *                              (((-'\ .' /
 *                            _____..'  .'
 *                           '-._____.-'
 */
(function() {
    var _matcher,
        _level = 0,
        _id = 0,
        _handlers = {},
        _gatorInstances = {};

    function _addEvent(gator, type, callback) {

        // blur and focus do not bubble up but if you use event capturing
        // then you will get them
        var useCapture = type == 'blur' || type == 'focus';
        gator.element.addEventListener(type, callback, useCapture);
    }

    function _cancel(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    /**
     * returns function to use for determining if an element
     * matches a query selector
     *
     * @returns {Function}
     */
    function _getMatcher(element) {
        if (_matcher) {
            return _matcher;
        }

        if (element.matches) {
            _matcher = element.matches;
            return _matcher;
        }

        if (element.webkitMatchesSelector) {
            _matcher = element.webkitMatchesSelector;
            return _matcher;
        }

        if (element.mozMatchesSelector) {
            _matcher = element.mozMatchesSelector;
            return _matcher;
        }

        if (element.msMatchesSelector) {
            _matcher = element.msMatchesSelector;
            return _matcher;
        }

        if (element.oMatchesSelector) {
            _matcher = element.oMatchesSelector;
            return _matcher;
        }

        // if it doesn't match a native browser method
        // fall back to the gator function
        _matcher = Gator.matchesSelector;
        return _matcher;
    }

    /**
     * determines if the specified element matches a given selector
     *
     * @param {Node} element - the element to compare against the selector
     * @param {string} selector
     * @param {Node} boundElement - the element the listener was attached to
     * @returns {void|Node}
     */
    function _matchesSelector(element, selector, boundElement) {

        // no selector means this event was bound directly to this element
        if (selector == '_root') {
            return boundElement;
        }

        // if we have moved up to the element you bound the event to
        // then we have come too far
        if (element === boundElement) {
            return;
        }

        // if this is a match then we are done!
        if (_getMatcher(element).call(element, selector)) {
            return element;
        }

        // if this element did not match but has a parent we should try
        // going up the tree to see if any of the parent elements match
        // for example if you are looking for a click on an <a> tag but there
        // is a <span> inside of the a tag that it is the target,
        // it should still work
        if (element.parentNode) {
            _level++;
            return _matchesSelector(element.parentNode, selector, boundElement);
        }
    }

    function _addHandler(gator, event, selector, callback) {
        if (!_handlers[gator.id]) {
            _handlers[gator.id] = {};
        }

        if (!_handlers[gator.id][event]) {
            _handlers[gator.id][event] = {};
        }

        if (!_handlers[gator.id][event][selector]) {
            _handlers[gator.id][event][selector] = [];
        }

        _handlers[gator.id][event][selector].push(callback);
    }

    function _removeHandler(gator, event, selector, callback) {

        // if there are no events tied to this element at all
        // then don't do anything
        if (!_handlers[gator.id]) {
            return;
        }

        // if there is no event type specified then remove all events
        // example: Gator(element).off()
        if (!event) {
            for (var type in _handlers[gator.id]) {
                if (_handlers[gator.id].hasOwnProperty(type)) {
                    _handlers[gator.id][type] = {};
                }
            }
            return;
        }

        // if no callback or selector is specified remove all events of this type
        // example: Gator(element).off('click')
        if (!callback && !selector) {
            _handlers[gator.id][event] = {};
            return;
        }

        // if a selector is specified but no callback remove all events
        // for this selector
        // example: Gator(element).off('click', '.sub-element')
        if (!callback) {
            delete _handlers[gator.id][event][selector];
            return;
        }

        // if we have specified an event type, selector, and callback then we
        // need to make sure there are callbacks tied to this selector to
        // begin with.  if there aren't then we can stop here
        if (!_handlers[gator.id][event][selector]) {
            return;
        }

        // if there are then loop through all the callbacks and if we find
        // one that matches remove it from the array
        for (var i = 0; i < _handlers[gator.id][event][selector].length; i++) {
            if (_handlers[gator.id][event][selector][i] === callback) {
                _handlers[gator.id][event][selector].splice(i, 1);
                break;
            }
        }
    }

    function _handleEvent(id, e, type) {
        if (!_handlers[id][type]) {
            return;
        }

        var target = e.target || e.srcElement,
            selector,
            match,
            matches = {},
            i = 0,
            j = 0;

        // find all events that match
        _level = 0;
        for (selector in _handlers[id][type]) {
            if (_handlers[id][type].hasOwnProperty(selector)) {
                match = _matchesSelector(target, selector, _gatorInstances[id].element);

                if (match && Gator.matchesEvent(type, _gatorInstances[id].element, match, selector == '_root', e)) {
                    _level++;
                    _handlers[id][type][selector].match = match;
                    matches[_level] = _handlers[id][type][selector];
                }
            }
        }

        // stopPropagation() fails to set cancelBubble to true in Webkit
        // @see http://code.google.com/p/chromium/issues/detail?id=162270
        e.stopPropagation = function() {
            e.cancelBubble = true;
        };

        for (i = 0; i <= _level; i++) {
            if (matches[i]) {
                for (j = 0; j < matches[i].length; j++) {
                    if (matches[i][j].call(matches[i].match, e) === false) {
                        Gator.cancel(e);
                        return;
                    }

                    if (e.cancelBubble) {
                        return;
                    }
                }
            }
        }
    }

    /**
     * binds the specified events to the element
     *
     * @param {string|Array} events
     * @param {string} selector
     * @param {Function} callback
     * @param {boolean=} remove
     * @returns {Object}
     */
    function _bind(events, selector, callback, remove) {

        // fail silently if you pass null or undefined as an alement
        // in the Gator constructor
        if (!this.element) {
            return;
        }

        if (!(events instanceof Array)) {
            events = [events];
        }

        if (!callback && typeof(selector) == 'function') {
            callback = selector;
            selector = '_root';
        }

        var id = this.id,
            i;

        function _getGlobalCallback(type) {
            return function(e) {
                _handleEvent(id, e, type);
            };
        }

        for (i = 0; i < events.length; i++) {
            if (remove) {
                _removeHandler(this, events[i], selector, callback);
                continue;
            }

            if (!_handlers[id] || !_handlers[id][events[i]]) {
                Gator.addEvent(this, events[i], _getGlobalCallback(events[i]));
            }

            _addHandler(this, events[i], selector, callback);
        }

        return this;
    }

    /**
     * Gator object constructor
     *
     * @param {Node} element
     */
    function Gator(element, id) {

        // called as function
        if (!(this instanceof Gator)) {
            // only keep one Gator instance per node to make sure that
            // we don't create a ton of new objects if you want to delegate
            // multiple events from the same node
            //
            // for example: Gator(document).on(...
            for (var key in _gatorInstances) {
                if (_gatorInstances[key].element === element) {
                    return _gatorInstances[key];
                }
            }

            _id++;
            _gatorInstances[_id] = new Gator(element, _id);

            return _gatorInstances[_id];
        }

        this.element = element;
        this.id = id;
    }

    /**
     * adds an event
     *
     * @param {string|Array} events
     * @param {string} selector
     * @param {Function} callback
     * @returns {Object}
     */
    Gator.prototype.on = function(events, selector, callback) {
        return _bind.call(this, events, selector, callback);
    };

    /**
     * removes an event
     *
     * @param {string|Array} events
     * @param {string} selector
     * @param {Function} callback
     * @returns {Object}
     */
    Gator.prototype.off = function(events, selector, callback) {
        return _bind.call(this, events, selector, callback, true);
    };

    Gator.matchesSelector = function() {};
    Gator.cancel = _cancel;
    Gator.addEvent = _addEvent;
    Gator.matchesEvent = function() {
        return true;
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Gator;
    } else {
        window.Gator = Gator;
    }
}) ();
},{}],13:[function(require,module,exports){
/* global PubSub + apply to call modification | https://github.com/dciccale/xxspubsub - 2012-04-30 - Downloaded on 2 Sep 2013 - Dennis Ciccale - MIT License */ 
;(function(e){var t={};e.publish=function(n,r){var i=t[n]||[],s=i.length;while(s--){i[s].call(e,r||[])}};e.subscribe=function(e,n){(t[e]=t[e]||[]).push(n);return[e,n]};e.unsubscribe=function(e){var n=t[e[0]],r=n.length;while(r--){if(n[r]===e[1]){n.splice(r,1)}}}})(this);
},{}]},{},[10])

